import { render, staticRenderFns } from "./PartAdd.vue?vue&type=template&id=b03b19b4"
import script from "./PartAdd.vue?vue&type=script&lang=ts"
export * from "./PartAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports